<template>
	<article class="d-content-page">
		<header class="text-white w-full pt-[35px] mb-[30px]">
			<h1
				v-if="title || name"
				class="text-45 font-light mb-[10px]"
				v-html="title || name"
			></h1>

			<p
				v-if="teaser"
				class="whitespace-pre-line text-22 <760:text-14"
				v-html="teaser"
			></p>
		</header>

		<BlockList
			v-if="elements?.length"
			:block-list="elements"
			class="w-full grid grid-cols-1 gap-[10px]"
		/>
	</article>
</template>

<script>
export default {
	inheritAttrs: false,
};
</script>

<script setup>
defineProps({
	id: Number,
	title: String,
	name: String,
	teaser: String,
	header: Object,
	elements: Array,
});
</script>

<style lang="postcss">
.d-content-page {
	@apply text-white flex flex-col justify-center w-full max-w-layout-max pb-[80px] mx-auto px-layout-margin;
}
</style>
